/* Generates strong random passwords client-side. */
const LOWER = "abcdefghijklmnopqrstuvwxyz";
const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const DIGITS = "0123456789";
const SYMBOLS = "!@#$%^&*()-_=+[]{};:,.<>?/~";

function secureRandomInt(max) {
  const buf = new Uint32Array(1);
  window.crypto.getRandomValues(buf);
  return buf[0] % max;
}

export function generatePassword({
  length = 20,
  useLower = true,
  useUpper = true,
  useDigits = true,
  useSymbols = true,
} = {}) {
  let pool = "";
  const required = [];
  if (useLower) {
    pool += LOWER;
    required.push(LOWER[secureRandomInt(LOWER.length)]);
  }
  if (useUpper) {
    pool += UPPER;
    required.push(UPPER[secureRandomInt(UPPER.length)]);
  }
  if (useDigits) {
    pool += DIGITS;
    required.push(DIGITS[secureRandomInt(DIGITS.length)]);
  }
  if (useSymbols) {
    pool += SYMBOLS;
    required.push(SYMBOLS[secureRandomInt(SYMBOLS.length)]);
  }
  if (!pool) pool = LOWER;
  const out = [...required];
  while (out.length < length) {
    out.push(pool[secureRandomInt(pool.length)]);
  }
  // shuffle
  for (let i = out.length - 1; i > 0; i--) {
    const j = secureRandomInt(i + 1);
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out.join("").slice(0, length);
}

/* Returns 0..4 strength score plus a label. */
export function scorePassword(pw) {
  if (!pw) return { score: 0, label: "Empty", color: "var(--vault-text-tertiary)" };
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 14) score++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  if (pw.length >= 20) score++;
  // collapse to 0..4
  const s = Math.min(4, Math.max(0, score - 1));
  const map = [
    { label: "Weak", color: "#C05746" },
    { label: "Fair", color: "#DD6B20" },
    { label: "Good", color: "#D4A017" },
    { label: "Strong", color: "#38A169" },
    { label: "Excellent", color: "#2F9E6B" },
  ];
  return { score: s, ...map[s] };
}
